import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    container: {
        width: '96%',
        boxSizing: 'border-box',
        backgroundColor: 'white',
        border: '1px solid #E3E3FA',
        borderRadius: 10
    },
    text: {
        textAlign: 'left',
        color: '#1F2152',
        fontSize: '1.2rem',
        padding: '1em',
        margin: 0,
        fontWeight: 600
    }
}));

const SearchEmpty = () => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <p className={classes.text}>
                No Member Found
            </p>
        </div>
    );
};

export default SearchEmpty; 